import api from './api';

export const getDashboardStats = () => api.get('/v1/dashboard/stats');
export const getLeaveSummary = () => api.get('/v1/dashboard/leave-summary');
export const getApproachingBirthdays = () => api.get('/v1/dashboard/approaching-birthdays');
export const getWorkAnniversaries = () => api.get('/v1/dashboard/work-anniversaries');
export const getMyPersonnel = () => api.get('/v1/dashboard/my-personnel');
export const getOnLeaveToday = () => api.get('/v1/dashboard/on-leave-today');
export const getAgeDistribution = () => api.get('/v1/dashboard/age-distribution');
export const getDepartmentDistribution = () => api.get('/v1/dashboard/department-distribution');
export const getSeniorityDistribution = () => api.get('/v1/dashboard/seniority-distribution');
export const getProfile = () => api.get('/v1/auth/profile');
